import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function DrawerHeader({
  title, description, onClose, size, type, className, children
}) {
  return (
    <div className={classNames('pgn__drawer-header', `drawer-header-${size}`, className)}>
      <div className="drawer-header-right">
        {(type === 'leftIcon' && size === 'sm') && <i className={classNames('drawer-icon', `drawer-icon-${size}`, 'ri-history-fill')} />}
        {(type === 'leftIcon' && size === 'lg') && <i className={classNames('drawer-icon', `drawer-icon-${size}`, 'ri-history-fill')} />}
        <div className={classNames('drawer-header-texts', `drawer-header-texts-${size}`)}>
          <span className="drawer-header-title">{title}</span>
          {size === 'lg' && <p className="drawer-header-description">{description}</p>}
        </div>
        {children}
      </div>
      <div className="drawer-header-end">
        <i
          onClick={onClose}
          className="drawer-icon-close ri-close-fill"
          onKeyDown={onClose}
          role="button"
          tabIndex={0}
          aria-label="Close drawer" // Add aria-label for accessibility
        />
      </div>
    </div>
  );
}

DrawerHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'lg']),
  type: PropTypes.oneOf(['basic', 'leftIcon']),
  className: PropTypes.string,
  children: PropTypes.node
};

DrawerHeader.defaultProps = {
  title: '',
  description: '',
  onClose: () => { },
  size: 'sm',
  type: 'basic',
  className: '',
  children: null
};

export default DrawerHeader;
